import React from 'react';
import renderHTML from 'react-render-html';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { Row, Col, Image } from 'react-bootstrap';
import iconPhone from '../../../../../assets/images/icon-phone.svg';
//import operation from '../../../../../components/SecurityFactors/config/OperationType';
import {formatCurrency} from '../../../../../utils/FormatUtil';


const InfoNI = (props) => {

    const { nombreCompleto, genero, invertible, montoLimitDap } = props;
    return (
        <div className="dap_info-socio">
            <h4>
                <FontAwesomeIcon icon={faInfoCircle} />
                {genero === "F" ? 'Estimada' : 'Estimado'} {nombreCompleto}:
            </h4>
            <p>
                Para la contratación de un Depósito a Plazo {!invertible && renderHTML(" sobre <strong>"+formatCurrency(montoLimitDap)+"</strong>")}, deberás acercarte a cualquiera de nuestras oficinas a lo largo de todo Chile.<br></br><br></br>
            </p>

            <Row>
                <Col md={2} xs={2} className="icon_dap_about_prop_phone">
                    <Image src={iconPhone} className="icono_dap_about" alt="Ícono DAP Phone" />
                </Col>
                <Col md={10} xs={10}>
                    Para más información, puedes llamar a nuestro Contact Center al <strong>600 200 1200.</strong>
                </Col>
            </Row>
        </div>
    );
}

export default InfoNI;